import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { JobsService } from 'core/services/jobs.service';
import { ModalComponent } from 'core/components/modal/modal.component';
import { ToastService } from '../../core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lms-reporting-tool',
  templateUrl: './reporting-tool.component.html',
  styleUrls: ['./reporting-tool.component.scss']
})
export class ReportingToolComponent implements OnInit, OnDestroy {
  @ViewChild('modalConfigReports', { static: false }) public modalConfigReports: ModalComponent;
  public report: string;
  public personalization: any;
  public selectedReportMode: string = 'licenses';
  public activeReportMode: string = 'licenses';
  public filters: any = {};
  public reportType: string;
  public reportModeOptions: { key: string; value: string }[] = [];
  private reportingSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private jobsService: JobsService,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    this.reportingSubscription = this.route.data.subscribe((routeData) => {
      const queryParams = {
        ...this.route.snapshot.queryParams
      };
      this.reportType = ['assessment', 'applicability', 'selfassessment'].includes(routeData.personalization?.type)
        ? routeData.personalization?.type
        : queryParams.reportType || '';
      this.filters = queryParams.clientId ? { clientId: queryParams.clientId } : {};
      this.report = routeData.report;
      this.activeReportMode = routeData.personalization?.type || 'licenses';
      this.selectedReportMode = this.activeReportMode;
      this.personalization = routeData.personalization;
      this.buildReportModeOptions();
    });
  }

  public ngOnDestroy(): void {
    this.reportingSubscription.unsubscribe();
  }

  // microfrontend gl-reports

  public openConfigModal(): void {
    this.selectedReportMode = this.activeReportMode;
    this.modalConfigReports.open();
  }

  public changeReportType(): void {
    this.activeReportMode = this.selectedReportMode;
    this.modalConfigReports.close();
  }

  saveReport(event) {
    this.personalization = event.detail.report;
    this.toastService.showOk('', 3000, false);
  }

  downloadReport(event) {
    if (event) {
      this.manageDownloadJob(event.detail.job.id);
    }
  }

  async manageDownloadJob(jobId) {
    this.jobsService.manageJob(jobId, this.jobsService.jobTypes.DOWNLOAD_REPORT);
  }

  private buildReportModeOptions(): void {
    this.reportModeOptions = [
      { key: 'licenses', value: this.translateService.instant('reports.licenses.configModeDefault') },
      { key: 'licensesDump', value: this.translateService.instant('reports.licenses.configModeDefaultWithIds') },
      { key: 'licensesBreakdown', value: this.translateService.instant('reports.licenses.configModeBreakdown') }
    ];
  }
}
